import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import BookingFlights from "./pages/BookingFlights";
import { useSelector } from "react-redux";
import { selectUser } from "./redux/userSlice";
import { selectAlert } from "./redux/alertSlice";
import SimpleAlert from "./components/Alert";
import SearchFlight from "./pages/SearchFlight";
import Loading from "./components/Loading";

// import BookingFlightPage from "./pages/BookingFlightPage";
// import Home from "./pages/Home";
// import Flights from "./pages/flights";
// import Hotels from "./pages/hotels";
// import Cars from "./pages/Cars";
// import BookingHotel from "./pages/BookingHotel";
// import BookingHotelPage from "./pages/BookingHotelPage";
// import Faq from "./pages/Faq";
// import PrivacyPolicy from "./pages/PrivacyPolicy";
// import SearchHotels from "./pages/SearchHotels";
// import PageNotFound from "./pages/PageNotFound/PageNotFound";
// import SignIn from "./pages/SignIn";
// import SignUp from "./pages/SignUp";
// import ChoosePayment from "./pages/ChoosePayment";
// import Paypal from "./pages/Paypal";
// import Square from "./pages/Square";
// import FlightDetail from "./pages/FlightDetail";
// import TermsAndCondition from "./pages/TermsAndCondition";
// import LandingPage from "./pages/LandingPage";
// import About from "./pages/About";
// import Contact from "./pages/contact";
// import SearchFlight2 from "./pages/SearchFlight2";
// import BookingFlightPage2 from "./pages/BookingFlightPage2";
// import LandingPageRevamp from "./pages/LandingPageRevamp";
// import ThankyouPage from "./pages/ThankyouPage";
// import Blog1 from "./pages/Blogs/Blog1";
// import Blog2 from "./pages/Blogs/Blog2";
// import Blog3 from "./pages/Blogs/Blog3";
// import Blog4 from "./pages/Blogs/Blog4";
// import Blog5 from "./pages/Blogs/Blog5";
// import Blog6 from "./pages/Blogs/Blog6";

const Home = lazy(() => import("./pages/Home"));
const Flights = lazy(() => import("./pages/flights"));
const Hotels = lazy(() => import("./pages/hotels"));
const Cars = lazy(() => import("./pages/Cars"));
const BookingHotel = lazy(() => import("./pages/BookingHotel"));
const BookingHotelPage = lazy(() => import("./pages/BookingHotelPage"));
const Faq = lazy(() => import("./pages/Faq"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const SearchHotels = lazy(() => import("./pages/SearchHotels"));
const SignIn = lazy(() => import("./pages/SignIn"));
const SignUp = lazy(() => import("./pages/SignUp"));
const ChoosePayment = lazy(() => import("./pages/ChoosePayment"));
const Paypal = lazy(() => import("./pages/Paypal"));
const Square = lazy(() => import("./pages/Square"));
const FlightDetail = lazy(() => import("./pages/FlightDetail"));
const TermsAndCondition = lazy(() => import("./pages/TermsAndCondition"));
const LandingPage = lazy(() => import("./pages/LandingPage"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/contact"));
const SearchFlight2 = lazy(() => import("./pages/SearchFlight2"));
const BookingFlightPage2 = lazy(() => import("./pages/BookingFlightPage2"));
const LandingPageRevamp = lazy(() => import("./pages/LandingPageRevamp"));
const ThankyouPage = lazy(() => import("./pages/ThankyouPage"));
const BookingFlightPage = lazy(() => import("./pages/BookingFlightPage"));
const Holidays = lazy(() => import("./pages/Holidays"));
const Blog1 = lazy(() => import("./pages/Blogs/Blog1"));
const Blog2 = lazy(() => import("./pages/Blogs/Blog2"));
const Blog3 = lazy(() => import("./pages/Blogs/Blog3"));
const Blog4 = lazy(() => import("./pages/Blogs/Blog4"));
const Blog5 = lazy(() => import("./pages/Blogs/Blog5"));
const Blog6 = lazy(() => import("./pages/Blogs/Blog6"));
const PageNotFound = lazy(() => import("./pages/PageNotFound/PageNotFound"));

function App() {
  // trave -agency functions
  const currentUser = useSelector(selectUser);
  const showAlert = useSelector(selectAlert);

  const RequireAuth = ({ children }) => {
    return currentUser ? children : <Navigate to="/login" />;
  };
  const RequireAdmin = ({ children }) => {
    return currentUser.isAdmin ? children : <Navigate to="/" />;
  };
  const Login = ({ children }) => {
    return currentUser ? <Navigate to="/" /> : children;
  };
  return (
    <div className="App">
      {showAlert && <SimpleAlert />}
      <Router>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Flights" element={<Flights />} />
            <Route path="/Hotels" element={<Hotels />} />
            <Route path="/Cars" element={<Cars />} />
            <Route path="/Holidays" element={<Holidays />} />
            <Route path="/book-hotel-page" element={<BookingHotel />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            {/* <Route path="/search-flights" element={<SearchFlight />} /> */}
            <Route path="/search-hotels" element={<SearchHotels />} />
            <Route path="/search-flights" element={<SearchFlight2 />} />
            <Route path="/flight-booking" element={<FlightDetail />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/TermsAndCondition" element={<TermsAndCondition />} />
            <Route path="/LandingPage" element={<LandingPage />} />
            <Route path="/booking" element={<LandingPageRevamp />} />
            <Route path="/ThankyouPage" element={<ThankyouPage />} />
            <Route path="/New-York-or-Los-Angeles" element={<Blog1 />} />
            <Route path="/Best-Travel-Destinations" element={<Blog2 />} />
            <Route
              path="/Travel-Agents-Reveal-the-Cheapest-Flights"
              element={<Blog3 />}
            />
            <Route
              path="/Ten-Most-Beautiful-National-Parks"
              element={<Blog4 />}
            />
            <Route
              path="/Ten-amazing-places-to-get-cheap-holiday"
              element={<Blog5 />}
            />
            <Route
              path="/Ten-PLACES-TO-PLAN-YOUR-HOLIDAYS"
              element={<Blog6 />}
            />
            <Route
              path="/flight-checkout"
              element={
                <RequireAuth>
                  <BookingFlightPage />
                </RequireAuth>
              }
            />
            <Route path="/flight-checkout2" element={<BookingFlightPage2 />} />
            <Route
              path="/hotel-checkout"
              element={
                <RequireAuth>
                  <BookingHotelPage />
                </RequireAuth>
              }
            />
            <Route
              path="/login"
              element={
                <Login>
                  <SignIn />
                </Login>
              }
            />
            <Route
              path="/signup"
              element={
                <Login>
                  <SignUp />
                </Login>
              }
            />
            <Route
              path="/choose-payment"
              element={
                // <RequireAuth>
                <ChoosePayment />
                // </RequireAuth>
              }
            />
            <Route
              path="/paypal"
              element={
                <RequireAuth>
                  <Paypal />
                </RequireAuth>
              }
            />
            <Route
              path="/square"
              element={
                <RequireAuth>
                  <Square />
                </RequireAuth>
              }
            />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
